const MEDIA_OBJECT = {
  TYPES: {
    VIDEO: 'video',
    LIVESTREAM: 'livestream',
    GAME: 'game'
  }
}

export default MEDIA_OBJECT
